import wrapWithProvider from "./wrapRootElement";
export const wrapRootElement = wrapWithProvider;
